import { render, staticRenderFns } from "./InfoTooltip.vue?vue&type=template&id=134a8b3a&scoped=true&"
import script from "./InfoTooltip.vue?vue&type=script&lang=js&"
export * from "./InfoTooltip.vue?vue&type=script&lang=js&"
import style0 from "./InfoTooltip.vue?vue&type=style&index=0&id=134a8b3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134a8b3a",
  null
  
)

export default component.exports